document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  bar.hidden = false;

  /* ---------- Show / hide on scroll ---------- */

  // The bar appears once the page's own Add to Cart button has scrolled
  // out of view, so the two are never on screen together.
  var mainBtn = document.querySelector('[data-add-to-cart-btn]');

  function updateVisibility() {
    var show;

    if (mainBtn) {
      var rect = mainBtn.getBoundingClientRect();
      // Scrolled past it (above the viewport), or not yet reached it.
      show = rect.bottom < 0 || rect.top > window.innerHeight;
    } else {
      // No main button found - fall back to a simple scroll distance.
      show = window.scrollY > 500;
    }

    bar.classList.toggle('is-visible', show);
  }

  updateVisibility();

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
    },
    { passive: true }
  );
  window.addEventListener('resize', updateVisibility);

  /* ---------- Quantity stepper ---------- */

  var qtyInput = bar.querySelector('[data-sticky-qty]');
  var minusBtn = bar.querySelector('[data-sticky-minus]');
  var plusBtn = bar.querySelector('[data-sticky-plus]');

  function currentQty() {
    return parseInt(qtyInput.value, 10) || 1;
  }

  function setQty(value) {
    qtyInput.value = Math.max(1, value);
    minusBtn.disabled = currentQty() <= 1;
  }

  if (qtyInput && minusBtn && plusBtn) {
    setQty(currentQty());

    minusBtn.addEventListener('click', function () {
      setQty(currentQty() - 1);
    });

    plusBtn.addEventListener('click', function () {
      setQty(currentQty() + 1);
    });

    qtyInput.addEventListener('change', function () {
      setQty(currentQty());
    });
  }

  /* ---------- Keep in sync with the main product form ----------
     When a variant is selected on the page, the theme updates the
     hidden id input in the main form. Mirror that into this bar so the
     correct variant is added, and refresh the price shown here. */

  var mainVariantInput = document.querySelector('[data-variant-id]');
  var stickyVariantInput = bar.querySelector('[data-sticky-variant-id]');
  var stickyPrice = bar.querySelector('[data-sticky-price]');
  var stickyCompare = bar.querySelector('[data-sticky-compare]');
  var mainPrice = document.querySelector('[data-product-price]');
  var mainCompare = document.querySelector('[data-product-compare-price]');

  function syncFromMainForm() {
    if (mainVariantInput && stickyVariantInput) {
      stickyVariantInput.value = mainVariantInput.value;
    }
    if (mainPrice && stickyPrice) {
      stickyPrice.textContent = mainPrice.textContent.trim();
    }
    if (mainCompare && stickyCompare) {
      stickyCompare.textContent = mainCompare.textContent.trim();
      stickyCompare.hidden = mainCompare.hasAttribute('hidden');
    }
  }

  if (mainVariantInput) {
    // The theme sets the variant id by script rather than by user input,
    // so watch the attribute instead of listening for a change event.
    new MutationObserver(syncFromMainForm).observe(mainVariantInput, {
      attributes: true,
      attributeFilter: ['value'],
    });

    // Variant pickers that fire a change event on the page.
    document.addEventListener('change', function (e) {
      if (e.target.closest('.custom-product-form')) {
        setTimeout(syncFromMainForm, 50);
      }
    });
  }
});